import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    width: '73%',
    height: '30rem',
  },
}));

export default useStyles;
